import React, { useContext, useState,useEffect } from "react";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import { FiDownload } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";
import ScrollAnimation from "../components/ScrollAnimations";
import "./Donation.css";

// Import Images
import Annadan1 from "../assets/Annachatra01.JPG";
import Annadan2 from "../assets/Annachatra02.JPG";
import Annadan3 from "../assets/annachtra.png";
import Annadan4 from "../assets/annachatra03.JPG";
import Hospital1 from "../assets/hospital.jpg";
import Hospital2 from "../assets/moredada_hospital.jpg";
import Hospital3 from "../assets/moredada_hospital01.jpg";
import Hospital4 from "../assets/Sadaguru Moredada Charitable Hospital 3D1.jpg";
// Placeholder images for new tabs - replace with actual images
import Gograss1 from "../assets/godaanseva.jpeg";
import Gograss2 from "../assets/goshala2.jpg";
import Gograss3 from "../assets/goshala3.jpg";

import Jankalyan1 from "../assets/jankalyan_yojana.jpeg";
import Jankalyan2 from "../assets/jankalyan_yojana1.jpeg";
import Gurupeeth1 from "../assets/gurupeeth1.jpg";
import Gurupeeth2 from "../assets/gurupith.jpg";
import Gurupeeth3 from "../assets/SABHAMANDAP.jpg";
import Gurupeeth4 from "../assets/Ayurved.jpg";

const tabData = {
  en: [
   
    {
      id: "gograss",
      title: "Gokul Gouniwas Gaushala, Dindori",
      description: `Indian civilisation has regarded the cow as the Mother and its milk as elixir. Modern sciences have also now conceded the healing properties of cow's milk, curd, clarified butter, cow urine and cowdung together called Panchgavya in Sanskrit.

To reaffirm its faith in and gratitude towards the holy cow, Shree Swami Samarth Krushi Vikas V Sanshodhan Charitable Trust has established a Goshala with many native breeds of cows. The primary aim of the Goshala is to preserve the native varieties (Indian breeds) of cows. A lot of Indian breeds like Khilar, Sahiwal and Dangi are protected in the Goshala.`,
      highlights: [
        "Over 900 sqm shelter to provide protection for over 2000 cows",
        "Separate ultra modern processing facilities for cow urine & Panchgavya",
        "Preservation of native Indian cow breeds (Khilar, Sahiwal, Dangi)",
        "Modern veterinary care and medical facilities",
        "Organic fodder cultivation and storage",
        "Panchgavya production and distribution center"
      ],
      contact: {
        bank: "Axis Bank Ltd",
        accountName: "Shree Swami Samarth Krushi Vikas Va Sanshodhan charitable trust (Gograss)",
        accountNumber: "913020017723777",
        IFSC: "UTIB0000471",
        email: "account.dindori@yahoo.com",
        phone: "9922420012",
      },
      images: [Gograss1, Gograss2, Gograss3],
      donationLinks: [
        { label: "Donate for Gograss Seva", href: "https://rzp.io/l/8HuzInng" },
      ],
    },
    
    {
      id: "hospital",
      title: "Sadguru Moredada Charity Hospital & Jankalyan Yojana",
      description: "This 1,000-bed multi-specialty hospital spreads over 21 acres, combining nature therapy and advanced medical care. It aims to provide affordable, high-quality healthcare to millions, especially the underprivileged. Your contribution helps build and sustain this vital institution.",
      contact: {
        bank: "State Bank of India",
        accountName: "Sadguru P P Moredada Charitable Hospital and Medical Trust",
        accountNumber: "37819876509",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "02594-234253/54",
      },
      images: [Hospital1, Hospital2, Hospital3, Hospital4],
      donationLinks: [
        { label: "Donate for Hospital", href: "https://pages.razorpay.com/dindoripranit" },
      ],
    },
  
    {
      id: "gurupeeth",
      title: "Shree Gurupeeth",
      description: "Contribute to the general development and maintenance of the Shree Gurupeeth. Your donation supports infrastructure upkeep, administrative functions, and the expansion of spiritual and social activities, ensuring the Gurupeeth continues to be a beacon of light and service for all devotees.",
      contact: {
        bank: "State Bank of India",
        accountName: "Akhil BharatiyaShree Swami Samarth Gurupith Trimbakeshwar",
        accountNumber: "37563481474",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "02594-234253/54",
      },
      images: [Gurupeeth1, Gurupeeth2, Gurupeeth3, Gurupeeth4],
      donationLinks: [
        // { label: "Donate to Shree Gurupeeth", href: "https://pages.razorpay.com/dindoripranit" },
      ],
    },
    {
      id: "annadaan",
      title: "Annadaan (Prasadalay)",
      description: "The Prasadalaya serves thousands of devotees daily. This modern facility features a solar-powered kitchen and hygienic storage, providing free, sanctified meals. The act of 'Annadaan' (donating food) is considered one of the highest forms of service. Be a part of this noble cause.",
      contact: {
        bank: "State Bank of India",
        accountName: "Akhil BharatiyaShree Swami Samarth Gurupith Trimbakeshwar",
        accountNumber: "37563481474",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "9881739771",
      },
      images: [Annadan1, Annadan2, Annadan3, Annadan4],
      donationLinks: [
        { label: "Annadaan Seva", href: "https://rzp.io/l/AnnadaanSeva" },
        { label: "Dattadham Pangat Donation", href: "https://rzp.io/l/DattadhamAnnadaan" },
      ],
    },
  ],
  mr: [
   {
      id: "gograss",
      title: "गोकुळ गौनिवास गोशाळा, दिंडोरी",
      description: `भारतीय संस्कृतीत गाय ही माता मानली गेली आहे आणि तिचे दूध अमृत मानले जाते. आधुनिक विज्ञानाने देखील गाईचे दूध, दही, तूप, गोमूत्र आणि शेण यांचे एकत्रितपणे पंचगव्य म्हणून औषधी गुणधर्म स्वीकारले आहेत.

पवित्र गाईप्रती आपला विश्वास आणि कृतज्ञता पुष्टी करण्यासाठी, श्री स्वामी समर्थ कृषी विकास व संशोधन धर्मादाय ट्रस्टने अनेक देशी जातींच्या गायींसह गोशाळा स्थापन केली आहे. गोशाळेचे प्राथमिक उद्दिष्ट देशी जातींच्या (भारतीय जाती) गायींचे संरक्षण करणे आहे. खिल्लारी, साहिवाल आणि डांगी यासारख्या अनेक भारतीय जातींचे गोशाळेत संरक्षण केले जाते.`,
      highlights: [
        "२००० पेक्षा जास्त गायींना संरक्षण प्रदान करण्यासाठी ९०० चौ.मी. पेक्षा जास्त निवारा",
        "गोमूत्र आणि पंचगव्यासाठी स्वतंत्र अत्याधुनिक प्रक्रिया सुविधा",
        "देशी भारतीय गाय जातींचे संरक्षण (खिल्लारी, साहिवाल, डांगी)",
        "आधुनिक पशुवैद्यकीय सेवा आणि वैद्यकीय सुविधा",
        "सेंद्रिय चाऱ्याची लागवड आणि साठवण",
        "पंचगव्य उत्पादन आणि वितरण केंद्र"
      ],
      contact: {
        bank: "ऍक्सिस बँक लिमिटेड",
        accountName: "श्री स्वामी समर्थ कृषी विकास व संशोधन धर्मार्थ ट्रस्ट (गोग्रास)",
        accountNumber: "913020017723777",
        IFSC: "UTIB0000471",
        email: "account.dindori@yahoo.com",
        phone: "९९२२४२००१२",
      },
      images: [Gograss1, Gograss2, Gograss3],
      donationLinks: [
        { label: "गोग्रास सेवेसाठी देणगी द्या", href: "https://rzp.io/l/8HuzInng" },
      ],
    },
    {
      id: "hospital",
      title: "सद्गुरू मोरेदादा हॉस्पिटल आणि जनकल्याण योजना",
      description: "हे १,००० खाटांचे मल्टी-स्पेशालिटी रुग्णालय २१ एकर परिसरात पसरलेले आहे, ज्यात निसर्गोपचार आणि प्रगत वैद्यकीय सेवा एकत्र आहेत. याचा उद्देश लाखो लोकांना, विशेषतः वंचितांना, परवडणारी, उच्च-गुणवत्तेची आरोग्यसेवा प्रदान करणे आहे. आपले योगदान ही महत्त्वपूर्ण संस्था तयार करण्यास आणि टिकवून ठेवण्यास मदत करते. 'जनकल्याण योजना' ही एक व्यापक लोककल्याणकारी योजना आहे जी समुदाय विकास, वंचित मुलांसाठी शिक्षण, आपत्ती निवारण आणि पर्यावरण संवर्धनावर लक्ष केंद्रित करते. आपले समर्थन आम्हाला समाजात चिरस्थायी सकारात्मक प्रभाव निर्माण करणारे विविध प्रकल्प हाती घेण्यास सक्षम करते.",
      contact: {
        bank: "स्टेट बँक ऑफ इंडिया",
        accountName: "सद्गुरु प.पू. मोरेदादा चॅरिटेबल हॉस्पिटल अँड मेडिकल ट्रस्ट",
        accountNumber: "37819876509",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "०२५९४-२३४२५३/५४",
      },
      images: [Hospital1, Hospital2, Hospital3, Hospital4],
      donationLinks: [
        { label: "रुग्णालयासाठी देणगी द्या", href: "https://rzp.io/l/sadguruhospital" },
      ],
    },
    {
      id: "gurupeeth",
      title: "श्री गुरुपीठ",
      description: "श्री गुरुपीठाच्या सामान्य विकास आणि देखभालीसाठी योगदान द्या. आपली देणगी पायाभूत सुविधांची देखभाल, प्रशासकीय कार्ये आणि आध्यात्मिक व सामाजिक उपक्रमांच्या विस्तारासाठी मदत करते, ज्यामुळे गुरुपीठ सर्व भक्तांसाठी प्रकाश आणि सेवेचे प्रतीक बनून राहील.",
      contact: {
        bank: "स्टेट बँक ऑफ इंडिया",
        accountName: "अखिल भारतीय श्री स्वामी समर्थ गुरुपिठ त्रिंबकेश्वर",
        accountNumber: "37563481474",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "०२५९४-२३४२५३/५४",
      },
      images: [Gurupeeth1, Gurupeeth2, Gurupeeth3, Gurupeeth4],
      donationLinks: [
        
      ],
    },
    {
      id: "annadaan",
      title: "अन्नदान (प्रसादालय)",
      description: "प्रसादालय दररोज हजारो भाविकांची सेवा करते. या आधुनिक सुविधेत सौरऊर्जेवर चालणारे स्वयंपाकघर आणि आरोग्यदायी साठवणूक व्यवस्था आहे, ज्यामुळे मोफत, पवित्र भोजन दिले जाते. 'अन्नदान' हे सेवेच्या सर्वोच्च प्रकारांपैकी एक मानले जाते. या उदात्त कार्यात सहभागी व्हा.",
      contact: {
        bank: "स्टेट बँक ऑफ इंडिया",
        accountName: "अखिल भारतीय श्री स्वामी समर्थ गुरुपिठ त्रिंबकेश्वर",
        accountNumber: "37563481474",
        IFSC: "SBIN0006292",
        email: "account@gurupeeth.in",
        phone: "९८८१७३९७७१",
      },
      images: [Annadan1, Annadan2, Annadan3, Annadan4],
      donationLinks: [
        { label: "अन्नदान सेवा", href: "https://rzp.io/l/AnnadaanSeva" },
        { label: "दत्तधाम पंगत देणगी", href: "https://rzp.io/l/DattadhamAnnadaan" },
      ],
    },
  ],
};

const commonTexts = {
  en: {
    header: "Donation",
    contactInfo: "Contact Info",
    donationDetails: "Donation Details",
    gallery: "Gallery",
    commonEmail: "contact@ma.dindoripranit.org", // Add this
    dindoriAddress: "Shri Swami Samarth Seva & Spiritual Development Center\nDindori, Taluka: Dindori, District: Nashik 422202",
    trimbakAddress: "Trimbakeshwar, Nashik, Maharashtra, India – 422212",
  },
  mr: {
    header: "देणगी",
    contactInfo: "संपर्क माहिती",
    donationDetails: "देणगी तपशील",
    gallery: "गॅलरी",
    commonEmail: "contact@ma.dindoripranit.org", // Add this (email remains same but can be changed if needed)
    dindoriAddress: "श्री स्वामी समर्थ सेवा व आध्यात्मिक विकास केंद्र\nदिंडोरी, तालुका: दिंडोरी, जिल्हा: नाशिक ४२२२०२",
    trimbakAddress: "त्र्यंबकेश्वर, नाशिक, महाराष्ट्र, भारत – ४२२२१२",
    compliance: {
      title: "पावती व करसवलत",
      points: [
        "सर्व देणग्यांना आयकर कायदा कलम 80G अंतर्गत करसवलत लागू.",
        "बँक/ऑनलाइन देणगीनंतर व्यवहार तपशील ईमेलद्वारे पाठवा; घरपोच/ईमेल स्कॅन पावती मिळेल.",
        "तपशील पाठवताना: व्यवहाराची स्लिप/स्क्रीनशॉट, UTR (NEFT साठी), PAN, मोबाईल, पूर्ण पत्ता समाविष्ट करा.",
        "कोणत्याही प्रश्नासाठी वरील संपर्कावर संपर्क साधा.",
      ],
    },
  },
};

export default function Donation() {
  const { lang } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState(0);
  const [zoomImg, setZoomImg] = useState(null);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (zoomImg) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [zoomImg]);
  const t = tabData[lang];
  const common_t = commonTexts[lang];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, arrows: false, dots: true } },
    ],
  };

  return (
    <div className="donation-page">
      <Header />

      <ScrollAnimation animation="fade-down">
        <header className="donation-header">
          <div className="header-center">
            <div className="breadcrumb">
              <Link to="/">Home</Link> / <span>{common_t.header}</span>
            </div>
            <h1>{common_t.header}</h1>
          </div>
        </header>
      </ScrollAnimation>

      <main className="donation-main">
        <div className="tabs-container">
          {t.map((tab, index) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        <div className="tab-content">
          {t.map((tab, index) => (
            <div key={tab.id} className={`tab-pane ${activeTab === index ? "active" : ""}`}>
              <section className="donation-info-section">
                <ScrollAnimation animation="fade-up" delay={100}>
                  <h2>{tab.title}</h2>
                  <p>{tab.description}</p>
                </ScrollAnimation>

                <ScrollAnimation animation="fade-up" delay={200}>
                  <h3>{common_t.contactInfo}</h3>
                </ScrollAnimation>
              <div className="contact-info-cards">
  <ScrollAnimation animation="slide-up" delay={100}>
    <div className="contact-card">
      <BsPinMapFill className="icon icon-address" />
      <p style={{ whiteSpace: 'pre-line' }}>{common_t.dindoriAddress}</p>
    </div>
  </ScrollAnimation>
  <ScrollAnimation animation="slide-up" delay={150}>
    <div className="contact-card">
      <BsEnvelope className="icon icon-email" />
      <p>{common_t.commonEmail}</p>
    </div>
  </ScrollAnimation>
  <ScrollAnimation animation="slide-up" delay={200}>
    <div className="contact-card">
      <BsPinMapFill className="icon icon-address" />
      <p>{common_t.trimbakAddress}</p>
    </div>
  </ScrollAnimation>
  <ScrollAnimation animation="slide-up" delay={250}>
    <div className="contact-card">
      <BsPhone className="icon icon-phone" />
      <p>{tab.contact.phone}</p>
    </div>
  </ScrollAnimation>
  <ScrollAnimation animation="slide-up" delay={300}>
    <div className="contact-card">
      <BsEnvelope className="icon icon-email" />
      <p>{tab.contact.email}</p>
    </div>
  </ScrollAnimation>
</div>

                {/* === UPDATED DONATION DETAILS SECTION === */}
               <ScrollAnimation animation="fade-up" delay={300}>
  <div className="donation-header">
    <h3>{common_t.donationDetails}</h3>
    <div className="direct-donation-buttons">
      {tab.donationLinks.map((link, i) => (
        <a
          key={i}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-donate btn-direct"
        >
          {link.label}
        </a>
      ))}
    </div>
  </div>
</ScrollAnimation>


                 <ScrollAnimation animation="fade-up" delay={500}>                      
                <div className="donation-details-wrapper">
                  <ScrollAnimation animation="slide-up" delay={100}>
                    <div className="detail-row">
                      <strong className="detail-label">Bank:</strong>
                      <span className="detail-value">{tab.contact.bank}</span>
                    </div>
                  </ScrollAnimation>
                  <ScrollAnimation animation="slide-up" delay={200}>
                    <div className="detail-row">
                      <strong className="detail-label">Account Name:</strong>
                      <span className="detail-value">{tab.contact.accountName}</span>
                    </div>
                  </ScrollAnimation>
                  <ScrollAnimation animation="slide-up" delay={300}>
                    <div className="detail-row">
                      <strong className="detail-label">Account Number:</strong>
                      <span className="detail-value">{tab.contact.accountNumber}</span>
                    </div>
                  </ScrollAnimation>
                  <ScrollAnimation animation="slide-up" delay={400}>
                    <div className="detail-row">
                      <strong className="detail-label">IFSC Code:</strong>
                      <span className="detail-value">{tab.contact.IFSC}</span>
                    </div>
                  </ScrollAnimation>
                </div>

                 
                </ScrollAnimation>

                {lang === "mr" && common_t.compliance && (
                  <ScrollAnimation animation="fade-up" delay={500}>
                    <h3>{common_t.compliance.title}</h3>
                    <ul>
                      {common_t.compliance.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  </ScrollAnimation>
                )}

                <ScrollAnimation animation="fade-up" delay={600}>
                  <section className="donation-gallery">
                    <h2>{common_t.gallery}</h2>
                    <Slider {...sliderSettings} className="gallery-slider">
                      {tab.images.map((img, i) => (
                        <div key={i} className="gallery-slide-wrapper">
                          <div className="gallery-item" onClick={() => setZoomImg(img)}>
                            <img src={img} alt={`${tab.title} ${i + 1}`} />
                            <div className="gallery-overlay">View</div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </section>
                </ScrollAnimation>
              </section>
            </div>
          ))}
        </div>
      </main>

      {zoomImg && (
        <div className="zoom-modal" onClick={() => setZoomImg(null)}>
          <AiOutlineClose
            className="zoom-close-icon"
            onClick={(e) => {
              e.stopPropagation();
              setZoomImg(null);
            }}
            size={28}
          />
          <img src={zoomImg} alt="Zoomed" />
          <a
            href={zoomImg}
            download
            className="download-icon"
            onClick={(e) => e.stopPropagation()}
          >
            <FiDownload size={24} />
          </a>
        </div>
      )}
    </div>
  );
}